var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPromotionDiscount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7363_324449)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.8125 1.11475H27.267V32.5431L23.1538 29.6651L19.5801 32.1189L16.0397 29.6651L12.4994 32.1189L8.92571 29.6651L4.8125 32.5431V1.11475ZM6.01542 2.31767V30.2333L8.91924 28.2015L12.4962 30.6575L16.0397 28.2015L19.5833 30.6575L23.1603 28.2015L26.0641 30.2333V2.31767H6.01542Z",
    fill: "#F6931E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.92595 22.7673H7.0189V21.5644H9.92595V22.7673Z",
    fill: "#F6931E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8369 22.7673H11.9298V21.5644H14.8369V22.7673Z",
    fill: "#F6931E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8491 22.7673H16.9421V21.5644H19.8491V22.7673Z",
    fill: "#F6931E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6656 25.3736L5.41398 25.3736L5.41398 24.1707L26.6656 24.1707V25.3736Z",
    fill: "#F6931E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8611 22.7673H21.9541V21.5644H24.8611V22.7673Z",
    fill: "#F6931E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.277 7.25398L12.1548 16.3761L11.3043 15.5255L20.4264 6.40339L21.277 7.25398Z",
    fill: "#F6931E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4335 9.53519C13.8765 9.53519 14.2355 9.17614 14.2355 8.73324C14.2355 8.29034 13.8765 7.9313 13.4335 7.9313C12.9906 7.9313 12.6316 8.29034 12.6316 8.73324C12.6316 9.17614 12.9906 9.53519 13.4335 9.53519ZM13.4335 10.7381C14.5408 10.7381 15.4384 9.8405 15.4384 8.73324C15.4384 7.62599 14.5408 6.72838 13.4335 6.72838C12.3263 6.72838 11.4287 7.62599 11.4287 8.73324C11.4287 9.8405 12.3263 10.7381 13.4335 10.7381Z",
    fill: "#F6931E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8465 15.1488C19.2894 15.1488 19.6484 14.7898 19.6484 14.3469C19.6484 13.9039 19.2894 13.5449 18.8465 13.5449C18.4036 13.5449 18.0445 13.9039 18.0445 14.3469C18.0445 14.7898 18.4036 15.1488 18.8465 15.1488ZM18.8465 16.3517C19.9537 16.3517 20.8514 15.4541 20.8514 14.3469C20.8514 13.2396 19.9537 12.342 18.8465 12.342C17.7392 12.342 16.8416 13.2396 16.8416 14.3469C16.8416 15.4541 17.7392 16.3517 18.8465 16.3517Z",
    fill: "#F6931E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7363_324449"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.3125)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromotionDiscount);
export default __webpack_public_path__ + "static/media/promotion-discount.942001e6df7f22b7f26412afac409bc2.svg";
export { ForwardRef as ReactComponent };